// Business-day helpers.
// Requirement: operational day starts at 07:00 local time.

export const BUSINESS_DAY_START_HOUR = 7;

const formatLocalDateISO = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const getBusinessDateISO = (now = new Date(), startHour = BUSINESS_DAY_START_HOUR) => {
  const d = new Date(now);
  if (d.getHours() < startHour) {
    d.setDate(d.getDate() - 1);
  }
  return formatLocalDateISO(d);
};

